import React from "react";
import { Drawer, DialogTitle, IconButton } from "@mui/material";
import SystemRoleForm from "./SystemRoleForm";
import { Cancel } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { styles } from "utils/apis";;

const AddSystemRole = ({ mode, open, handleClose,setMode }) => {
    const {defaultData} = useSelector(({category})=>category);
    return (
        <>
            <Drawer
                anchor={"bottom"}
                open={open}
                onClose={handleClose}
                sx={styles}     
            >
                <DialogTitle sx={{display: "flex", justifyContent: "flex-end", padding: 0}}>
                    <IconButton onClick={handleClose} sx={{color:"purple"}}>
                        <Cancel />
                    </IconButton>
                </DialogTitle>
                <SystemRoleForm mode={mode} setMode={setMode}defaultData={defaultData} handleClose={handleClose} />
            </Drawer>
        </>
    )
}
export default AddSystemRole;